import { render } from "./observacionesdelimpieza.vue?vue&type=template&id=0558b3e5&scoped=true"
import script from "./observacionesdelimpieza.vue?vue&type=script&lang=js"
export * from "./observacionesdelimpieza.vue?vue&type=script&lang=js"

import "./observacionesdelimpieza.vue?vue&type=style&index=0&id=0558b3e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0558b3e5"]])

export default __exports__